<template>
  <transition name="modal-fade">
    <div id="modalEditBanner" class="dibble-modal">
      <div class="modal small-m">
        <div
          class="modal-dialog modal-form "
          role="document"
          style="width: 600px"
        >
          <div class="modal-content" style="min-width: 600px !important;">
            <div class="modal-header">
              <p class="title-modal" v-text="(data ? 'Edit' : 'Add') + ' Designation'"></p>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                @click="closeModal"
              >
                <img src="@/assets/images/close-dialog.svg" alt="close-icon">
              </button>
            </div>
            <div class="modal-body form-box mt-2">
              <div class="user-modal-content" style="overflow: hidden !important;">
                <div class="row mt-2 pl-2 pr-2">
                  <div class="col-md-12">
                    <TextField
                      v-model="item.title"
                      name="title"
                      label="Designation Name"
                    />
                  </div>
                  <div class="col-md-12">
                    <TextField
                      v-model="item.code"
                      name="code"
                      label="External Code"
                    />
                  </div>
                </div>
              </div>
              <div>
                <div class="d-flex justify-content-center mt-2">
                  <button v-text="'Save'"
                          :disabled="!item.title"
                          class="btn-dialog btn-sm ok-btn" @click="save">
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import TextField from '@/commons/FormElements/TextField.vue';
import DibbleJs from "@/dibble";
import DibbleApi from "@/api";

export default {
  name: "ModalDesignationForm",
  components: {TextField},
  props: {
    data: Object
  },
  data() {
    return {
      item: {
        id: '',
        title: '',
        code: ''
      }
    };
  },
  created() {
    if (this.data) {
      this.item.title = this.data.name
      this.item.code = this.data.external_code
      this.item.id = this.data.designation_id
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    add() {
      DibbleJs.showLoader();
      const data = {
        '#request': DibbleApi.api.designationAdd,
        name: this.item.title,
        external_code: this.item.code,
      };
      DibbleJs.callApiRequest(data, (response) => {
        if (DibbleApi.isResponseSuccess(response)) {
          DibbleJs.toastSuccessMessage('Designation has been added');
          this.$emit("success");
        } else {
          DibbleJs.toastErrorMessage(response.message);
        }
        DibbleJs.hideLoader();
      });
    },
    update() {
      DibbleJs.showLoader();
      const data = {
        '#request': DibbleApi.api.designationUpdate,
        designation_id: this.item.id,
        name: this.item.title,
        external_code: this.item.code,
      };
      DibbleJs.callApiRequest(data, (response) => {
        if (DibbleApi.isResponseSuccess(response)) {
          DibbleJs.toastSuccessMessage('Designation has been updated');
          this.$emit("success");
        } else {
          DibbleJs.toastErrorMessage(response.message);
        }
        DibbleJs.hideLoader();
      });
    },
    save() {
      if (this.item.id) {
        this.update()
      } else {
        this.add()
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-content {
  min-width: 500px !important;
}

.modal-content, .modal-body {
  background: #EDF5F7 !important;
  border-radius: 60px !important;
  padding: 10px 20px;
}

.modal-header {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center;
  padding: 10px 0px !important;
  border-bottom: 1.5px solid #1C5169;
  margin: 0 20px !important;

  .title-modal {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 22px;
    line-height: 22px;
    letter-spacing: 0.01em;
    color: #1C5169;
    margin-top: 0 !important;
  }

  button {
    border: none !important;
    outline: none !important;
    background: initial;
  }
}

.user-modal-content {
  max-height: 500px;
  overflow: scroll;
}

.btn-dialog.btn-sm {
  font-size: 14px;
  height: 40px;
}

.donation-checkbox {
  .checkbox-item {
    display: flex;
  }

  .checkbox-custom {
    position: inherit;
    width: 40px;
    height: 40px;

    .checkmark-new {
      border-radius: 5px;
      background: #41B8DC;

      &.not-active {
        background: #dde6e9;
      }
    }
  }

  p {
    color: #555E67;
  }
}
</style>
